import { action, makeAutoObservable, observable } from 'mobx';

import { Continent, Match, User, UserDetailed } from '@/domain';

export interface ViewedUser {
  id: number;
  time: number;
}

type LocationSettings = {
  filter_continents: Continent[];
  filter_option: 'country' | 'world';
  discover_near: boolean;
};

class DiscoveryStore {
  users: UserDetailed[] = [];
  usersViewedHistory: ViewedUser[] = [];

  /**
   * @deprecated use users instead
   */
  users_list: any = {
    users: observable([]),
    users_viewed: observable([]),
  };
  searchSettings: {
    match_gender: string;
    match_age_from: number;
    match_age_to: number;
    filter_verified_only: boolean | null;
  } = {
    match_gender: '',
    match_age_from: 0,
    match_age_to: 0,
    filter_verified_only: null,
  };
  locationSettings: any = {
    filter_continents: observable([]),
    filter_option: observable([]),
    discover_near: observable([]),
  };
  refresh: boolean | null = null;

  constructor() {
    makeAutoObservable(this, {
      setLocationSettings: action,
    });
  }

  setUsersUnsafe(users: Match[]) {
    this.users_list.users = users;
  }

  cleanUp() {
    this.users = [];
  }

  getUserByIfd(id: number) {
    return this.users.find((user) => user.id === id);
  }

  setUsers(users: UserDetailed[]) {
    this.users = users;
  }

  addUsers(users: UserDetailed[]) {
    if (!users || users.length === 0) {
      return;
    }

    const existingUserIds = new Set(this.users.map((user) => user.id));
    const newUsers = users.filter((user) => !existingUserIds.has(user.id));
    this.users = [...this.users, ...newUsers];
  }

  prependUser(user: UserDetailed) {
    const existingUser = this.users.find((u) => u.id === user.id);

    if (existingUser) {
      return;
    }

    this.users = [user, ...this.users];
  }

  deleteUser(user: User) {
    this.users = this.users.filter((storedUser) => storedUser.id !== user.id);
  }

  addViewedUser(user: ViewedUser) {
    if (
      user &&
      !this.users_list.users_viewed.some(
        (existingUser: ViewedUser) => existingUser.id === user.id
      )
    ) {
      this.users_list.users_viewed.unshift(user);
    }
  }
  deleteUserFromViewedUsers(id: number) {
    this.users_list.users_viewed = this.users_list.users_viewed.filter(
      (u: ViewedUser) => u.id !== id
    );
  }
  setLocationSettings(data: LocationSettings) {
    this.locationSettings = data;
  }
  clearLocationSettings() {
    this.locationSettings = {};
  }
  clearSearchSettings() {
    this.searchSettings = {
      match_gender: '',
      match_age_from: 0,
      match_age_to: 0,
      filter_verified_only: null,
    };
  }
  updateMatchGender(gender: string) {
    this.searchSettings.match_gender = gender;
  }

  updateMatchAgeFrom(age: number) {
    this.searchSettings.match_age_from = age;
  }

  updateMatchAgeTo(age: number) {
    this.searchSettings.match_age_to = age;
  }

  updateFilterVerifiedOnly(verified: boolean) {
    this.searchSettings.filter_verified_only = verified;
  }
  updateRefresh(refresh: boolean) {
    this.refresh = refresh;
  }
}

const discoveryStore = new DiscoveryStore();
export default discoveryStore;
